var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Table } from '../../../components';
import history from '../../../helpers/History';
import { T } from '../../../helpers/i18n';
var SettingCashMovementsTable = /** @class */ (function (_super) {
    __extends(SettingCashMovementsTable, _super);
    function SettingCashMovementsTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCreate = function () { return history.push('/settingcashmovements/create'); };
        _this.handleSelectItem = function (value) { return history.push("/settingcashmovements/".concat(value.id)); };
        return _this;
    }
    SettingCashMovementsTable.prototype.render = function () {
        var data = this.props.settingCashMovements;
        var datos = data.map(function (value) {
            var temp = {};
            Object.assign(temp, value);
            if (!!value.disabled_at) {
                temp.status = T('disabled');
            }
            else {
                temp.status = T('enabled');
            }
            temp.typeMovement = T(value.typeMovement);
            return temp;
        });
        var headers = ['typeMovement', 'name', 'concepto', 'status'];
        var filters = [
            {
                name: 'all',
                filter: function (item) { return true; }
            },
            {
                name: 'actives',
                filter: function (item) { return item.disabled_at === null; }
            }, {
                name: 'disabled',
                filter: function (item) { return item.disabled_at !== null; }
            }
        ];
        console.log('datos ', datos);
        return (React.createElement(Table, { items: datos, header: headers, filters: filters, onSelectItem: this.handleSelectItem, onCreate: this.handleCreate, keyExtractor: function (item) { return String(item.id); } }));
    };
    SettingCashMovementsTable = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.settingCashMovementStore.read().then(function (settingCashMovements) { return ({ settingCashMovements: settingCashMovements }); })
        ]; }),
        observer
    ], SettingCashMovementsTable);
    return SettingCashMovementsTable;
}(Component));
export default SettingCashMovementsTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/SettingCashMovements/containers/SettingCashMovementsTable.tsx
// module id = 1579
// module chunks = 0